export class ReturnPathHelper {
  public static extractReturnPathFromState(state: string | null): string | undefined {
    // The state is encoded as follows:
    // XXXXXXXXXX-customStateThatContainsOurReturnPath
    // - ourReturnPath is a string of alphanumeric tuples each representing a hex number
    // - each of those hex numbers represents an ascii char
    // - these ascii chars are the base64 representation of the original path
    //
    // Who came up with this hex/ascii thing? Amplify did (see signInWithRedirect()).

    // Split of encoded custom state
    const customState_hex_ascii = state?.split('-').slice(1).join('-');

    // hex and ascii decode to base64
    const customState_b64 = customState_hex_ascii
        ?.match(/.{2}/g)
        ?.map((h) => String.fromCharCode(parseInt(h, 16)))
        .join('');

    if (!customState_b64) {
        return undefined;
    }

    // base64 decode
    return atob(customState_b64);
  }

  public static appendReturnPathToState(state: string | null, path: string): string {
    // base64 encode the path
    const customState_b64 = btoa(path);

    // ascii to hex encode
    const customState_hex_ascii = Array.from(customState_b64)
        .map((c) => c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');

    // Append suffix
    return `${state}-${customState_hex_ascii}`;
  }
}